<template>
  <div class="type">
    <div class="tools ">
      <div class="tool_right flex_center">
        <el-form ref="searchForm" :inline="true" :model="form">
          <el-form-item label="车架号:">
            <el-input clearable v-model="form.vin"></el-input>
          </el-form-item>
          <el-form-item label="发动机型号:">
            <el-input clearable v-model="form.engineModel"></el-input>
          </el-form-item>
          <el-form-item label="发动机号:">
            <el-input clearable v-model="form.engineNumber"></el-input>
          </el-form-item>
          <el-form-item label="品牌:">
            <el-input clearable v-model="form.carBrand"></el-input>
            <!-- <el-select  clearable v-model="form.carBrand" placeholder="所有品牌">
                      <el-option v-for="(item,index) in brandList" :key="index" :label="item" :value="item"></el-option>
                    </el-select> -->
          </el-form-item>
          <el-form-item label="车型:">
            <el-input clearable v-model="form.carModel"></el-input>
            <!-- <el-select  clearable v-model="form.carModel" placeholder="所有品牌">
                      <el-option v-for="(item,index) in typeList" :key="index" :label="item" :value="item"></el-option>
                    </el-select> -->
          </el-form-item>
          <!-- <el-form-item label="车主姓名:" >
                  <el-input v-model="form.ownerName"></el-input>
                </el-form-item>
                <el-form-item label="车主联系方式:" label-width="120px">
                  <el-input v-model="form.ownerPhone" ></el-input>
                </el-form-item> -->
        </el-form>
      </div>
      <div class="tool flex">
        <el-button
          type="primary"
          size="small"
          @click="handleSearch"
        
          >查询</el-button
        >
        <!-- <el-button type="primary" size="small" @click="resetFields('searchForm')">重置</el-button> -->
        <el-button
          type="primary"
          size="small"
          @click="exportExcel"
        
          >导出</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="importMould"
       
          >获取导入模板</el-button
        >
        <el-upload
          class="upload-demo flex"
          :show-file-list="false"
          :headers="header"
          :action="imAction"
          multiple
          :on-change="handle"
        >
          <el-button  type="primary" size="small"
            >导入</el-button
          >
        </el-upload>
      </div>
    </div>

    <el-table
      v-loading="loading"
      :data="tableData"
      border
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="40" align="center"> </el-table-column>
      <el-table-column type="index" label="序号" width="50" align="center"> </el-table-column>
      <el-table-column prop="vin" label="车架号" :min-width="$getColumnWidth('vin',tableData)">
        <template slot-scope="scope">
          <p class="blue" @click="dialogDetail = true">{{ scope.row.vin }}</p>
        </template>
      </el-table-column>
      <!-- <el-table-column
            prop="ownerName"
            label="车主姓名"
            width="120">
          </el-table-column>
          <el-table-column
            prop="ownerPhone"
            label="车主联系方式"
            width="120">
          </el-table-column> -->
      <el-table-column prop="carBrand" label="品牌" :min-width="$getColumnWidth('carBrand',tableData)">
      </el-table-column>
      <el-table-column prop="carModel" label="车型" :min-width="$getColumnWidth('carModel',tableData)">
      </el-table-column>
      <el-table-column prop="productionDate" label="生产日期" :min-width="$getColumnWidth('productionDate',tableData)">
      </el-table-column>
      <el-table-column prop="salesDate" label="销售日期" :min-width="$getColumnWidth('salesDate',tableData)">
      </el-table-column>
      <el-table-column prop="specifications" label="配置" :min-width="$getColumnWidth('specifications',tableData)">
      </el-table-column>
      <el-table-column prop="engineNumber" label="发动机号" :min-width="$getColumnWidth('engineNumber',tableData)">
      </el-table-column>

      <el-table-column prop="engineModel" label="发动机型号" :min-width="$getColumnWidth('engineModel',tableData)">
      </el-table-column>
      <el-table-column prop="motorModel" label="电机号" :min-width="$getColumnWidth('motorModel',tableData)">
      </el-table-column>
      <el-table-column prop="carColor" label="车辆颜色" :min-width="$getColumnWidth('carColor',tableData)">
      </el-table-column>
      <el-table-column prop="staffName" label="更新人" :min-width="$getColumnWidth('staffName',tableData)">
      </el-table-column>
      <el-table-column prop="updateTime" label="更新时间" :min-width="$getColumnWidth('updateTime',tableData)">
      </el-table-column>
    </el-table>
    <div class="fenye">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page="page"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getDownloadFiles } from "@/util/downFile";
import { uploadUrl } from "@/util/url";
import {
  ownerList,
  getImportMould,
  exportOwner,
  brandAndType
} from "@/api/api";
export default {
  components: {},
  data() {
    return {
      // imAction:'http://43.157.63.49:8186/manage/owner/import',
      imAction: uploadUrl + "/manage/owner/import",
      // imAction:'/api/manage/owner/import',
      tableData: [],
      form: {
        vin: "",
        carBrand: "",
        carModel: "",
        engineModel: "",
        engineNumber: ""
      },
      page: 1,
      pageSize: 10,
      total: 0,
      brandList: [],
      typeList: [],
      header: {
        satoken: sessionStorage.getItem("token")
      },
      page: 1,
      pageSize: 10,
      total: 0,
      multipleSelection: [],
      loading: false
    };
  },
  created() {},
  mounted() {
    this.getList();
    this.getBrandAndType();

    // this.importMould()
  },
  methods: {
    // 复选框
    handleSelectionChange(val) {
      let arr = [];
      if (val.length > 0) {
        val.filter(item => {
          arr.push(item.vin);
          // return item.vin;
        });
        this.multipleSelection = arr;
      }
    },
    // 查询
    handleSearch() {
      this.page = 1;
      this.pageSize = 10;

      this.getList();
    },
    // 改变每页数量
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    // 翻页
    handlePageChange(val) {
      this.page = val;
      this.getList();
    },
    // 导入文件读取
    readFile(file) {
      // 文件读取
      return new Promise(resolve => {
        const reader = new FileReader();
        reader.readAsBinaryString(file); // 以二进制的方式读取
        reader.onload = ev => {
          resolve(ev.target.result);
        };
      });
    },
    // 上传表格
    async handle(ev) {
      if (ev.response.status == 0) {
        this.$DonMessage.success("上传成功")
        this.getList();
      } else {
        this.$DonMessage.error(ev.response.message);
      }
      return;
      const file = ev.raw;
      if (this.lastUid == file.uid) {
        return;
      }
      this.lastUid = file.uid;
      if (file) {
        if (
          file.name.indexOf(".xls") != -1 ||
          file.name.indexOf(".xlsx") != -1
        ) {
          // 这里进行了判断，只能读取这两种类型的文件。
          const data = await this.readFile(file);
          const workbook = XLSX.read(data, { type: "binary", cellDates: true }); // 解析二进制格式数据
          const worksheet = workbook.Sheets[workbook.SheetNames[0]]; // 获取第一个Sheet
          const result = XLSX.utils.sheet_to_json(worksheet); // json数据格式
          // this.$emit("filechange", result);//将数据通过filechange函数，传递给父组件
          this.list = result;
          this.workData();
        }
      }
    },
    // 处理表格数据
    workData() {
      const dataNew = []; // 新数组
      this.list.map(item => {
        const _item = JSON.parse(
          JSON.stringify(item)
            .replace("车架号", "vin")
            .replace("车主姓名", "ownerName")
            .replace("车主联系方式", "ownerPhone")
            .replace("品牌", "carBrand")
            .replace("车型", "carModel")
            .replace("生产日期", "productionDate")
            .replace("销售日期", "salesDate")
            .replace("发动机号", "engineNumber")
            .replace("发动机型", "engineModel")
            .replace("车辆颜色", "carColor")
        );
        dataNew.push(_item);
      });
      this.list = dataNew;
    },
    // 重置
    resetFields(formName) {
      this.$refs[formName].resetFields();
    },

    // 获取列表
    async getList() {
      this.loading = true;
      let brand = "";
      let model = "";
      if (this.form.carBrand == "全部") {
        brand = "";
      } else {
        brand = this.form.carBrand;
      }
      if (this.form.carModel == "全部") {
        model = "";
      } else {
        model = this.form.carModel;
      }

      let query = {
        data: {
          vin: this.form.vin,
          engineModel: this.form.engineModel,
          engineNumber: this.form.engineNumber,
          carBrand: brand,
          carModel: model
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize
        }
      };
      const res = await ownerList(query);
      if (res.status == 0) {
        this.total = res.data.count;
        this.tableData = res.data.records;
        this.loading = false;
      } else {
        this.message.error(res.message);
        this.loading = false;
      }
    },
    // 获取品牌 车型
    async getBrandAndType() {
      const res = await brandAndType();
      if (res.status == 0) {
        this.brandList = ["全部", ...res.data.carBrandSpinner];
        this.typeList = ["全部", ...res.data.carModelSpinner];
      }
    },
    // 获取导入模板
    async importMould() {
      const res = await getImportMould();
      getDownloadFiles(res);
      if (res.fileName) {
        this.$DonMessage.success("导入模板已下载！");
      }
    },
    // 导出
    async exportExcel() {
      let query = {
        data: {
          vin: this.form.vin,
          engineModel: this.form.engineModel,
          engineNumber: this.form.engineNumber,
          carBrand:
            this.form.carBrand == "全部"
              ? (this.form.carBrand = "")
              : this.form.carBrand,
          carModel:
            this.form.carModel == "全部"
              ? (this.form.carModel = "")
              : this.form.carModel,
          ownerCarRecordVinList: [...this.multipleSelection]
        },
        page: {
          pageNum: this.page,
          pageSize: this.pageSize
        }
      };
      const res = await exportOwner(query);
      getDownloadFiles(res);
      if (res.fileName) {
        this.$DonMessage.success("导出成功！");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.tools {
  margin-top: 15px;
}
.blue {
  color: #409eff;
  cursor: pointer;
}
.tool {
  margin: 15px 0;
}
.upload-demo {
  margin-left: 10px;
}
.type {
  padding-left: 20px;
  .select_box {
    margin-right: 30px;
    span {
      font-size: 14px;
      display: inline-block;
      margin-right: 15px;
    }
  }
  .search_box {
    padding-right: 20px;
  }
  .img {
    width: 120px;
  }
  .el-table {
    margin-top: 20px;
  }
}
</style>
